import { createFileRoute } from "@tanstack/react-router";
import { AvbestillPrivatAvtalePage } from "@/features/avtaler/components/avbestill/AvbestillPrivatAvtalePage";

export const Route = createFileRoute(
  "/_app/avtaler/$avtalerId/privat/avbestill/",
)({
  component: AvbestillPrivatAvtalePage,
  head: () => ({
    meta: [
      {
        title: "Avbestill | Norgespris for Fjernvarme",
      },
    ],
  }),
});
